import { usePermission } from "@/shared/hooks/usePermission";
import { useFailedJobs, useRetryJob } from "../hooks/useJobs";
import { FailedJobsTable } from "./FailedJobsTable";

interface FailedJobsPanelProps {
	queueName: string;
}

/**
 * ⚠️ Panel navbat TANLANGANDA mount qilinadi va yopilganda unmount
 * bo'ladi — `usePaginatedQuery` da `enabled` yo'q, ya'ni «navbat
 * tanlanmagan bo'lsa so'rov yubormaslik» shartini mount/unmount bilan
 * ifodalash yagona to'g'ri yo'l.
 */
export function FailedJobsPanel({ queueName }: FailedJobsPanelProps) {
	const query = useFailedJobs(queueName);
	const { can } = usePermission();
	const retry = useRetryJob();

	return (
		<FailedJobsTable
			query={query}
			canRetry={can("jobs", "retry")}
			retryingId={retry.isPending ? (retry.variables?.id ?? null) : null}
			onRetry={(job) => retry.mutate({ queue: queueName, id: job.id })}
		/>
	);
}
